import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/diga/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/diga/insert', data);
  },
  async update(data) {
    return await http.post('/api/diga/update', data);
  },
  async delete(data) {
    return await http.post('/api/diga/delete', data);
  }
};